module.exports = __webpack_public_path__ + "static/media/etsy-woven-bag.940a98f5.png";